import { AUTH_TYPES, AUTHORITY_TYPE } from "../../const";
import useAuthority from "../../hooks/useAuthority";

const IconButtonRenderer = ({
  clickHandler,
  type = "button",
  className = "ui button",
  icon,
  style = {},
  editMode = false,
  authType = AUTHORITY_TYPE.FORM,
  needDeletePermission = false,
  form = "-",
  field = "-",
  module = "-",
  authenticated = false,
  consider = AUTH_TYPES.VIEW,
  disabled = false,
  ...props
}) => {
  const { view, authorized } = useAuthority({
    type: authType,
    module: module,
    field: field,
    form: form,
    editMode: editMode,
    authenticated: authenticated,
    needDeletePermission,
  });

  return (
    <button
      {...props}
      className={className}
      type="button"
      onClick={clickHandler}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      disabled={
        disabled || (consider === AUTH_TYPES.VIEW ? !view : !authorized)
      }
    >
      {icon}
    </button>
  );
};

export default IconButtonRenderer;
